export function setCurrentTool (state, value) {
  state.currentTool = value
}

export function setQuery (state, query) {
  state.query = query
}
